import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore, REDIRECT_URL_KEY } from '@vantage-web/core-data';

/**
 * Protects the unified `/oip` staff portal routes.
 * Requires authentication + a staff role — **OIP (territory) or corporate (NBD)**.
 * Corporate is a role inside the single staff app (capability-gated nav +
 * national data-scoping), not a separate area, so corporate staff are admitted
 * here in all modes; in-page `isCorporate` checks + the API's territory scoping
 * decide what national vs territory data they see.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const store = inject(AuthStore);
  const router = inject(Router);

  if (!store.isAuthenticated()) {
    if (state.url !== '/auth/login') {
      localStorage.setItem(REDIRECT_URL_KEY, state.url);
    }
    return router.parseUrl('/auth/login');
  }

  const roleOk = store.isOipUser() || store.isCorpUser();
  if (!roleOk) {
    return router.parseUrl('/auth/login');
  }

  return true;
};
